import AutocompleteComponent from '../vd-autocomplete.component'

import controller from './vd-autocomplete-multi.controller'
import template from './vd-autocomplete-multi.html'

export default {
  ...AutocompleteComponent,
  bindings: {
    ...AutocompleteComponent.bindings,
    maxItems: '<',
    maxPlaceholder: '@',
  },
  controller,
  template,
}
